import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import {
  StyledBoxContent,
  StyledBoxDown,
  StyledButton,
  StyledButtonPlus
} from './style';

import InterestItem from './InterestItem';
import Modal from '../../../core/Modal';
import { INTERESTS } from '../../../../constants/literals/modals';
import { moveElementPosition } from '../../../../utils/splices';

class Interests extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: props.dataInterests,
      btnIsDisabled: true
    };
  }

  componentDidMount() {
    const { data } = this.state;

    if (data.length === 0) {
      this.handlePlus();
    }
  }

  onClickDelete = index => {
    const { data } = this.state;
    const updatedData = data.filter((ele, i) => i !== index);

    this.setState({
      data: updatedData,
      btnIsDisabled: this.getBtnStatus(updatedData)
    });
  };

  onClickOrderArrow = (index, isDown) => {
    const { data } = this.state;
    const move = isDown ? index + 1 : index - 1;
    const updatedData = moveElementPosition([...data], index, move);

    this.setState({
      data: updatedData,
      btnIsDisabled: this.getBtnStatus(updatedData)
    });
  };

  getBtnStatus = data => {
    const { dataInterests } = this.props;

    return _.isEqual(dataInterests, data);
  };

  handleAccept = () => {
    const { onAcceptModal } = this.props;
    const { data } = this.state;
    const updatedData = data.filter(ele => ele);

    onAcceptModal(updatedData);
  };

  handleChange = (value, index) => {
    const { data } = this.state;
    const clonedData = [...data];

    clonedData[index] = value;

    this.setState({
      data: clonedData,
      btnIsDisabled: this.getBtnStatus(clonedData)
    });
  };

  handlePlus = () => {
    const { data } = this.state;
    const clonedData = [...data];

    clonedData.push('');

    this.setState({
      data: clonedData,
      btnIsDisabled: this.getBtnStatus(clonedData)
    });
  };

  render() {
    const { onCloseModal } = this.props;
    const { data, btnIsDisabled } = this.state;

    return (
      <Modal title={INTERESTS.TITLE} clickCloseIcon={onCloseModal}>
        <StyledBoxContent>
          {data.map((item, index) => (
            <InterestItem
              key={`${item.interest}${index + 1}`}
              interest={item}
              onChangeInput={e => this.handleChange(e, index)}
              onClickDelete={() => this.onClickDelete(index)}
              onClickDown={() => this.onClickOrderArrow(index, true)}
              onClickUp={() => this.onClickOrderArrow(index, false)}
              order={index + 1}
            />
          ))}
          <StyledButtonPlus dark onClick={this.handlePlus} />
          <StyledBoxDown>
            <StyledButton onClick={onCloseModal} modal>
              {INTERESTS.CANCEL}
            </StyledButton>
            <StyledButton
              onClick={this.handleAccept}
              secondary
              disabled={btnIsDisabled}
            >
              {INTERESTS.ACCEPT}
            </StyledButton>
          </StyledBoxDown>
        </StyledBoxContent>
      </Modal>
    );
  }
}

Interests.propTypes = {
  dataInterests: PropTypes.arrayOf(PropTypes.string),
  onAcceptModal: PropTypes.func,
  onCloseModal: PropTypes.func
};

Interests.defaultProps = {
  dataInterests: []
};

export default Interests;
